<template>
  <div
    class="pageFooterBottom onLineIndex"
    :style="{
      background: `linear-gradient(180deg, ${bgColor} 8%, var(--bgColor) 260px`,
    }"
  >
    <Header
      :title="$route.query.name"
      bgColor="transparent"
      :isShadow="false"
      :isFixed="false"
    />
    <div class="pageContent carSatety">
      <section class="pageFlexBetweenb typeList" style="padding: 0px 20px">
        <div
          class="pageBigRadius pageCarServeShadow listItem"
          v-for="(item, index) in list"
          :key="index"
          :class="`${active === index ? 'active' : ''}`"
          @click="selItem(index)"
        >
          <KImg :src="item.src" />
          <p
            style="
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            "
          >
            {{ item.name }}
          </p>
          <van-icon v-if="active === index" class="icons" name="success" />
        </div>
        <VTitle val="车牌号" :showLine="false" />
        <Keyboards @sendCarNumber="getcrNumber"></Keyboards>
        <VTitle val="支付方式" :showLine="false" />
        <div class="payWay">
          <!-- <van-radio-group class="pageCard" v-model="checked">
            <van-cell-group>
              <van-cell @click="showCoupons(2)" class="balancePay coupons">
                <template #title>
                  <van-icon name="coupon-o" />
                  <span>通用券</span>
                </template>
                <div class="balanceRight">
                  <div class="right">
                    <van-icon name="arrow" />
                  </div>
                </div>
              </van-cell>
            </van-cell-group>
          </van-radio-group> -->
          <van-button
            class="pageDefaultRadius pageBannarShadow pageFontWeight clickPay"
            color="var(--depYelColor)"
            :disabled="true"
            @click="onComfirm"
            block
            id="paybtn"
          >
            <span>立即提交</span>
          </van-button>
        </div>
        <Tips :content="describe" v-if="describe != ''" />
      </section>
      <!-- 卡券余额支付列表 -->
      <van-popup
        v-model="couponsBalanceShow"
        round
        position="bottom"
        class="couponsBalanceList"
      >
        <div class="van-coupon-list">
          <div class="van-tabs__content">
            <div role="tabpanel" class="van-tab__pane" style="">
              <div
                class="van-coupon-list__list van-coupon-list__list--with-bottom"
              >
                <van-checkbox-group
                  v-model="couponsBalanceChecked"
                  ref="checkboxGroup"
                  @change="changeCheckboxes"
                >
                  <div class="van-coupon" @click="toggle(0, 0)">
                    <div class="van-coupon__content">
                      <div class="van-coupon__head">
                        <!-- <van-image :src="lgImg" width="32" height="32" /> -->
                        <van-icon
                          class="iconfont iconqiaquanguanli"
                          size="32"
                        />
                      </div>
                      <div class="van-coupon__body">
                        <p class="van-coupon__name">权益券</p>
                        <p class="van-coupon__valid">
                          <!-- <span>ID：{{ item.couponsId }}</span> -->
                          <span>到期时间：2025-2-20</span>
                        </p>
                      </div>
                    </div>
                    <div class="van-coupon__description">
                      <div class="left">
                        <p class="money">
                          余额
                          <span style="font-weight: 700; font-size: 16px"
                            >￥</span
                          ><span class="number">{{
                            $formatMoney(Number(9), 2).split(".")[0]
                          }}</span
                          ><span style="font-weight: 700; font-size: 18px"
                            >.{{
                              $formatMoney(Number(9), 2).split(".")[1]
                            }}</span
                          >
                        </p>
                        <!-- <p class="remark">备注：说明XXXXXXXX</p> -->
                      </div>
                      <div class="right">
                        <van-checkbox
                          checked-color="#f90"
                          ref="checkboxes"
                          name="item"
                          @click="checkboxclick"
                        ></van-checkbox>
                      </div>
                    </div>
                  </div>
                </van-checkbox-group>
              </div>
            </div>
          </div>
          <div class="van-coupon-list__bottom" style="position: fixed">
            <button
              class="van-button van-button--danger van-button--normal van-button--block van-button--round van-coupon-list__close"
              @click="couponsBalanceShow = false"
            >
              <div class="van-button__content">
                <span class="van-button__text">确定</span>
              </div>
            </button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import PayWay from "components/PayWay";
import Vswipe from "../index/Vswipe";
import defaultDate from "server/data/satety.json";
import Tips from "server/data/tips.json";
import Keyboards from "./components/keyboard.vue";
export default {
  components: {
    Vswipe,
    PayWay,
    Keyboards,
  },
  props: {
    banner: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bgColor: "var(--depYelColor)",
      list: [],
      lgImg: require("assets/banner_xlh.jpg"),
      active: 0,
      isQQ: false,
      isTx: false,
      sellData: { sell_price: -1 },
      tips: "",
      discount: 0,
      vip_discount: 0,
      wechatpay: false,
      describe: "",
      params: {},
      checked: true,
      balance: 0,
      isMember: false,
      type: "",
      couponsName: "",
      couponsDeduct: 0,
      couponsBalanceList: [],
      link: "",
      categoryId: 0,
      mouldId: 0,
      upstreamId: 0,
      buyerUserId: 0,
      sell_price: 0,
      couponsBalanceShow: false,
      couponsBalanceChecked: [],
      balanceChecked: false,
      couponType: 1,
      account: "",
    };
  },
  created() {
    this.list = defaultDate.list;
    for (let index = 0; index < this.list.length; index++) {
      const element = this.list[index];
      const src = element.src;
      this.list[index].src = require("assets/carSatety/" + src + ".svg");
    }
    this.hostname = location.hostname;
    this.tips = Tips.videoRecharge;
    this.bgColor = "#FFC300";
  },
  mounted() {},
  methods: {
    checkboxclick() {
      if (this.sell_price <= 0) {
        this.couponsBalanceChecked = [];
      }
    },
    selItem(index) {
      this.active = index;
    },
    changeCheckboxes(names) {
      let arryLists = "";
      let money = 0;
      for (let i = 0; i < names.length; i++) {
        const element = names[i];
        if (i == 0) {
          arryLists += element.couponsId;
        } else {
          arryLists += "," + element.couponsId;
        }
        money += Number(element.couponsBalance);
      }

      let remainder = this.sell_price - money;
      remainder = remainder > 0 ? money : this.sell_price;
      this.couponsDeduct = Number(remainder >= 0 ? remainder : 0);
      this.cards = arryLists;
      if (arryLists != "") {
        this.number = arryLists.split(",").length;
      } else {
        this.number = 0;
      }
    },
    toggle(index, is_can_use) {
      let now = this.$refs.checkboxes;
      now.toggle();
    },
    showCoupons(val) {
      let number = 0;
      this.number = number;
      if (this == 1) {
        that.showDialogs = true;
      } else {
        if (
          (this.params.card_id != undefined) &
          (this.sellData.sell_price == 0)
        ) {
          if (number == 0) {
            this.$error("当前卡券已抵扣支付金额");
          } else {
            this.couponsBalanceShow = true;
          }
        } else {
          this.couponsBalanceShow = true;
        }
      }
    },
    getcrNumber(val) {
      if (this.$regCarNo(val)) {
        this.account = val;
        this.params.account = this.account;
      }
    },
    onComfirm() {},
  },
};
</script>
<style scoped lang="less">
.carSatety {
  padding: 0px;
  .phone {
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    font-weight: 900;
    font-size: 20px;
    color: var(--redColor);
  }
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
}
.typeList {
  margin-bottom: -15px;
  .listItem {
    display: inline-block;
    width: 31%;
    position: relative;
    margin-bottom: 15px;
    margin-left: 6px;
    background: #fff;
    color: var(--assistantColor);
    padding: 5px 8px;
    box-sizing: border-box;
    .kimg {
      height: 32px;
    }
    p {
      font-size: 13px;
      text-align: center;
    }
    .icons {
      position: absolute;
      top: 3px;
      right: 3px;
      color: #fff;
      font-size: 10px;
      z-index: 2;
    }
  }
  .listItem:last-child:nth-child(3n + 2) {
    margin-right: calc((100% - 31%) / 2);
  }
  .active {
    color: var(--redColor);
    border-color: var(--redColor);
  }
  .active::after {
    content: "";
    border: 11px solid var(--redColor);
    border-left: 11px solid transparent;
    border-top: 11px solid transparent;
    border-bottom-right-radius: 10px;
    width: 0;
    height: 0;
    position: absolute;
    top: 2px;
    right: 1px;
    transform: rotate(-90deg);
    z-index: 1;
  }
  .active::before {
    content: "";
    position: absolute;
    top: 1px;
    right: 1px;
    bottom: 1px;
    left: 1px;
    border: 2px solid var(--redColor);
    border-radius: 10px;
    z-index: 3;
  }
}
.discount_coupons {
  background: inherit;
  color: #fff;
  .van-cell {
    padding: inherit;
    align-items: center;
    margin-bottom: 15px;
    box-shadow: #ccc 0 0 5px;
    background: red;
    color: #fff;
    border-radius: 10px;
    .van-cell__title {
      flex: inherit;
      /deep/ .van-tag {
        font-size: 12px;
      }
    }
    .van-cell__value {
      padding-left: 10px;
      text-align: left;
      color: #fff;
    }
    .van-radio {
      margin-right: 10px;
      color: #fff;
      border-color: #fff;
      border-width: 2px;
    }
    /deep/ .van-icon {
      border: 2px solid #f7f8fa;
    }
    /deep/ .van-checkbox__icon--checked {
      .van-icon {
        background-color: inherit;
        border-color: inherit;
      }
    }
    /deep/ .van-radio__icon--checked {
      .van-icon {
        background-color: inherit;
        border-color: inherit;
      }
    }
    .left {
      border-right: 2px solid #cccccc82;
    }
    .left_money {
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      width: 65px;
      padding-right: 15px;
      border-right: 2px solid #cccccc82;
      span {
        font-size: 18px;
      }
    }
    .left_time {
      background: #fff;
      color: red;
      border-radius: 10px;
      display: flex;
      align-items: center;
      /* justify-content: center; */
      height: 20px;
      font-size: 12px;
      span {
        padding: 0px 5px;
      }
    }
    .right_name {
      font-size: 16px;
      font-weight: bold;
    }
    .right_time {
      font-size: 14px;
    }
  }
}
.pageCard {
  padding: 0;
  .van-cell-group {
    border-radius: 10px;
  }
  .wechatModel {
    border-radius: 0px 0px 10px 10px;
  }
  .balancePay {
    border-radius: 10px 10px 0px 0px;
  }
  .balancePay2 {
    border-radius: 10px;
  }
  .coupons {
    border-radius: 10px 10px 0px 0px;
    .balanceRight {
      display: flex;
      align-items: center;
    }
    .tag {
      font-size: 12px;
      padding: 0px 5px;
      margin-left: 5px;
      color: #fff;
      background: #f90;
      height: 15px;
      display: flex;
      align-items: center;
      border-radius: 5px 0px 5px 0px;
    }
  }
  .van-icon-coupon-o {
    display: flex;
    align-items: center;
    font-size: 20px;
    margin-right: 8px;
    color: var(--depYelColor);
  }
}
.payWay {
  .van-cell {
    padding: 10px;
    justify-content: space-between;
    font-size: var(--middleFont);
  }
  .van-cell:last-child {
    border-radius: 10px;
  }
  .van-cell::after {
    border-color: #d2d2d2;
    left: 0;
    right: 0;
  }
  .van-cell__title,
  .van-cell__value {
    flex: initial;
    justify-content: center;
    display: flex;
  }
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none;
  }
  .iconfont {
    font-size: 22px;
    vertical-align: middle;
    margin-right: 8px;
  }
  .weixin {
    color: var(--greenColor);
  }
  .balance {
    color: var(--depYelColor);
  }
  .val {
    color: var(--assistantColor);
  }
  .labels {
    font-size: 16px;
    color: var(--redColor);
  }
  .labels:first-child {
    margin-right: 8px;
  }
  .van-checkbox {
    height: 24px;
  }
  .servicefee {
    margin-right: 15px;
    color: var(--redColor);
    font-size: 14px;
  }
  .clickPay {
    margin-top: 20px;
    height: 50px;
    span {
      font-size: 16px;
    }
  }
  .right {
    display: flex;
    float: right;
    align-items: center;
  }
}
.couponsBalanceList {
  height: 65%;
  background-color: rgb(247, 248, 250);
  .van-coupon-list__list {
    overflow-y: initial;
  }
  .van-coupon {
    border: 2px solid #ff9900;
    .van-coupon__content {
      background-image: linear-gradient(-90deg, #fceabb, #f8b500);
      color: #fff;
      min-height: initial;
      padding: 10px 0;
      .van-coupon__head {
        min-width: initial;
        padding: 0 15px;
      }
    }
    .van-coupon__body {
      .van-coupon__valid {
        display: flex;
        justify-content: space-between;
        margin-right: 15px;
      }
      .van-coupon__name {
        margin-bottom: 5px;
      }
    }
    .van-coupon__description {
      padding: 15px;
      border-top: initial;
      display: flex;
      justify-content: space-between;
      .left {
        width: 90%;
        text-align: center;
        line-height: 1.5;
        .money {
          color: red;
          font-size: 14px;
          .number {
            font-size: 30px;
            font-weight: 700;
          }
        }
        .remark {
          font-size: 14px;
          color: #ccc;
        }
      }
      .right {
        display: flex;
        align-items: center;
        /deep/
          .van-checkbox__icon--disabled.van-checkbox__icon--checked
          .van-icon {
          color: #fff;
          background: #f90;
          border-color: #f90;
        }
        /deep/ .van-checkbox__icon--disabled .van-icon {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
    }
  }
}
</style>
